import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { initPostHog } from '@/lib/posthog'

// Initialise analytics before the React tree mounts so the very first
// pageview (and any auto-captured clicks during initial render) are
// tagged correctly. No-ops when VITE_POSTHOG_KEY is unset.
initPostHog()

// Append environment indicator to title
const env = import.meta.env.VITE_NODE_ENV
if (env && env !== 'production') {
  document.title = `${document.title} (${env})`
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)